import ViewUsersPage from "components/viewUsers/ViewUsers.component"

const ViewUsers = () => {
  return (
    <ViewUsersPage />
  )
}

export default ViewUsers
